

































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: 'SuggestNeedStockInTable',
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() dataSource!: any;
    @PropSync('form') formSync!: any;
    @PropSync('formLading') formLadingSync!: any;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50,
            fixed: 'left'
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            scopedSlots: {customRender: "ladingCode"},
            width: 150,
            ellipsis: true,
            fixed: 'left'
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "weightTemp",
            key: "weightTemp",
            scopedSlots: {customRender: "weightTemp"},
            width: 100,
            ellipsis: true
        },
        {
            title: "TLTC(g)",
            dataIndex: "weight",
            key: "weight",
            scopedSlots: {customRender: "weight"},
            width: 100,
            ellipsis: true
        },
        {
            title: "Địa chỉ nhận",
            dataIndex: "locationTo",
            key: "locationTo",
            scopedSlots: {customRender: "locationTo"},
            width: 500,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100,
            fixed: 'right'
        }
    ];

    deleteLading(id: string) {
        const lading = WarehouseStore.stockInLadings[id];
        if (lading?.ladingCode === this.formLadingSync.ladingCode) {
            this.formLadingSync = {} as any;
        }
        WarehouseStore.deleteStockInLading([id]);
        this.formSync.ladingRowGuids = this.formSync.ladingRowGuids.filter((ladingRowGuid: string) => ladingRowGuid != id);
    }

    onSelectChange(selectedRowKeys: string[]) {
        this.formSync.ladingRowGuids = selectedRowKeys as any;
    }
}
